import { render, staticRenderFns } from "./default_AppFooter.vue?vue&type=template&id=7cd668b0&"
import script from "./default_AppFooter.vue?vue&type=script&lang=js&"
export * from "./default_AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./default_AppFooter.vue?vue&type=style&index=0&id=7cd668b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports